import MapModel from './maps/MapModel';
import MapView from './maps/MapView';
import MapLocationList from './maps/MapLocationList';
import MapObjectBaloonManager from './maps/MapObjectBaloonManager';
import { mapUrl, mapData } from './maps/map-data';
import $ from 'jquery';

const mapModel = new MapModel(mapData, mapUrl);

const mapView = new MapView(mapModel, {
  instance: $('.js-homepage-map'),
  container: $('.js-homepage-map-cont'),
  nav: $('.js-homepage-map-nav'),
});

new MapLocationList(
  mapModel,
  {
    list_items: $('.js-map-item-list li a'),
  },
  mapView,
);

new MapObjectBaloonManager(mapModel, mapView);



// WEBPACK FOOTER //
// ./src/js/bundle_homepage.js